import type {
  DomainRouterConnection,
  DomainRouterJsonInput,
} from '@triedge/domain-core';
import type {
  PortalDocument,
  PortalResource,
  PortalStudentProfile,
  PortalTransaction,
} from './index';
import type { CalendarEvent } from '@triedge/admissions-domain';

export type PortalStudentProfileListResponse = DomainRouterConnection<PortalStudentProfile>;
export type PortalDocumentListResponse = DomainRouterConnection<PortalDocument>;
export type PortalTransactionListResponse = DomainRouterConnection<PortalTransaction>;

export const PARENT_PORTAL_QUERY_OPERATION_IDS = [
  'listPortalStudentProfiles',
  'listPortalDocuments',
  'listPortalCalendarEvents',
  'listPortalTransactions',
  'listPortalResources',
] as const;

export const PARENT_PORTAL_MUTATION_OPERATION_IDS = [] as const;

export type ParentPortalQueryOperationId = (typeof PARENT_PORTAL_QUERY_OPERATION_IDS)[number];
export type ParentPortalMutationOperationId = never;

export type ParentPortalQueryArgsMap = {
  listPortalStudentProfiles: { input?: DomainRouterJsonInput };
  listPortalDocuments: { input?: DomainRouterJsonInput };
  listPortalCalendarEvents: { input?: DomainRouterJsonInput };
  listPortalTransactions: { input: DomainRouterJsonInput };
  listPortalResources: { input?: DomainRouterJsonInput };
};

export type ParentPortalQueryResultMap = {
  listPortalStudentProfiles: PortalStudentProfileListResponse;
  listPortalDocuments: PortalDocumentListResponse;
  listPortalCalendarEvents: CalendarEvent[];
  listPortalTransactions: PortalTransactionListResponse;
  listPortalResources: PortalResource[];
};

export type ParentPortalMutationArgsMap = Record<never, never>;
export type ParentPortalMutationResultMap = Record<never, never>;
